import fontawesome from '@fortawesome/fontawesome';
import faBars from '@fortawesome/fontawesome-free-solid/faBars';
require('./assets/css/main.scss');
require('./assets/js/stickyMenu');

//Require the bars.
fontawesome.library.add(faBars);


// WEBPACK FOOTER //
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/vendor/underpin/header-nav/index.js